import { render, staticRenderFns } from "./ArticleHotBeautyContainer.vue?vue&type=template&id=25b33d6c&"
import script from "./ArticleHotBeautyContainer.vue?vue&type=script&lang=js&"
export * from "./ArticleHotBeautyContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports